var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6008622,4 C14.2464177,4 17.2017244,6.91053515 17.2017244,10.5008622 C17.2017244,11.9445751 16.7238693,13.2783697 15.9154311,14.3572055 L20,18.3835568 L18.3601272,20 L14.2316417,15.9308191 C13.1900328,16.6077203 11.9421676,17.0017244 10.6008622,17.0017244 C6.95530667,17.0017244 4,14.0911892 4,10.5008622 C4,6.91053515 6.95530667,4 10.6008622,4 Z M10.6008622,6 C8.05987617,6 6,8.01510464 6,10.5008622 C6,12.9866197 8.05987617,15.0017244 10.6008622,15.0017244 C13.1418482,15.0017244 15.2017244,12.9866197 15.2017244,10.5008622 C15.2017244,8.01510464 13.1418482,6 10.6008622,6 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2a5daf3ea205285a856f28b6448deaa7.svg";
export { ForwardRef as ReactComponent };